import { useEffect, useMemo, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from 'views/components/Footer/Footer'
import UserService from 'Main/service/UserService'
import SidebarPanel from './SidebarPanel'
import { getPageTitle } from 'Main/Utils'

export default function MainLayout () {
  const location = useLocation()
  const userService = useMemo(() => new UserService(), [])
  const [user, setUser] = useState(null)
  const [mobileOpen, setMobileOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('artapay-sidebar-collapsed') === 'true')

  useEffect(() => {
    let active = true
    userService.getUser().then((response) => {
      if (active) setUser(response?.data || null)
    }).catch(() => {})
    return () => { active = false }
  }, [userService])

  useEffect(() => {
    setMobileOpen(false)
  }, [location.pathname])

  const toggleCollapsed = () => {
    setCollapsed((current) => {
      localStorage.setItem('artapay-sidebar-collapsed', String(!current))
      return !current
    })
  }

  return (
    <div className={`artapay-shell${collapsed ? ' is-collapsed' : ''}${mobileOpen ? ' is-mobile-open' : ''}`}>
      <SidebarPanel
        user={user}
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      <button
        type="button"
        className="artapay-sidebar-scrim"
        aria-label="Close navigation"
        onClick={() => setMobileOpen(false)}
      />

      <div className="artapay-main">
        <header className="artapay-topbar">
          <div className="artapay-topbar-start">
            <button
              type="button"
              className="artapay-icon-button artapay-mobile-menu"
              aria-label="Open navigation"
              onClick={() => setMobileOpen(true)}
            >
              <i className="fa-solid fa-bars" />
            </button>
            <button
              type="button"
              className="artapay-icon-button artapay-desktop-collapse"
              aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
              onClick={toggleCollapsed}
            >
              <i className={`fa-solid ${collapsed ? 'fa-angles-right' : 'fa-angles-left'}`} />
            </button>
            <div>
              <span className="artapay-eyebrow">COMMAND CENTER</span>
              <h1>{getPageTitle(location.pathname)}</h1>
            </div>
          </div>

          <div className="artapay-topbar-end">
            {/* <span className="artapay-api-state"><span /> API connected</span> */}
            <div className="artapay-user-chip">
              <div className="artapay-user-avatar">{(user?.name || user?.username || 'A').charAt(0).toUpperCase()}</div>
              <div>
                <strong>{user?.name || user?.username || 'ArtaPay user'}</strong>
                <small>{user?.type || 'Session active'}</small>
              </div>
            </div>
          </div>
        </header>

        <main className="artapay-content">
          <Outlet />
        </main>
        <Footer fluid />
      </div>
    </div>
  )
}
